export const tag_list_art_periods_jp = [
  '1940年代',
  '1950年代',
  'アート',
  'アールヌーボー',
  'バロック',
  'バウハウス',
  'コンテンポラリー',
  'ゴシック',
  'グラフィティ',
  '印象派',
  'モダニズム',
  'サイケデリック',
  'パンク',
  'レトロ',
  'ストリートアート',
];

export const tag_list_colours_jp = [
  'アクア',
  'ブラック',
  '白黒',
  'ブルー',
  '青と白',
  'ブライト',
  'ブラウン',
  'カラフル',
  'コーラル',
  'クリーム',
  'シアン',
  'ダーク',
  'ダークブルー',
  'ダークグリーン',
  'ゴールド',
  'グリーン',
  'グレー',
  'インディゴ',
  '玉虫色',
  'ライト',
  'ライラック',
  'マゼンタ',
  'マルチカラー',
  'ネイビー',
  'ネオン',
  'オレンジ',
  'パステル',
  'ピンク',
  'パープル',
  'レッド',
  'シルバー',
  'ティール',
  'ターコイズ',
  'ビビッド',
  'バイオレット',
  'ホワイト',
  'イエロー',
];

export const tag_list_pattern_types_jp = [
  '3D',
  'アフリカン',
  'アズテック',
  'バンダナ',
  'バティック',
  'ボタニカル',
  'ブーケ',
  'カートゥーン',
  'シェブロン',
  'シノワズリ',
  'サークル',
  'ダマスク',
  'デコラティブ',
  '小花柄',
  'ドゥードゥル',
  'ドット',
  '刺繍',
  'エキゾチック',
  'フォーク',
  'フォークロア',
  'フーラード',
  'ギンガム',
  'ガールズ',
  'ハワイアン',
  'ハート',
  'ヘリンボーン',
  'ハウンドトゥース',
  'イカット',
  'イラスト',
  'インディアン',
  'ジャカード',
  '和風',
  '着物',
  'ニット',
  'レース',
  'ラージスケール',
  'マンダラ',
  'マーブル',
  'メキシカン',
  'モロッカン',
  'モザイク',
  'モチーフ',
  '北欧風',
  'オリエンタル',
  'オーナメンタル',
  'ペイズリー',
  'パッチワーク',
  'スカーフ',
  'シェイプ',
  '絞り染め',
  'シンプル',
  'スモールスケール',
  'スペーシング',
  'スポット',
  'スクエア',
  'スター',
  'タータン',
  'タイダイ',
  'トライアングル',
  '織り',
  'ジグザグ',
];

export const tag_list_pattern_techniques_jp = [
  'アブストラクトフラワー',
  'アーティスティック',
  'ビッグフラワー',
  'ブラー',
  '大胆',
  'ブラシストローク',
  'コラージュ',
  'キュート',
  'ディテール',
  'デジタル',
  'ディストーション',
  'フェード',
  'フローリッシュ',
  'ファン',
  'フューチャリスティック',
  'グラフィック',
  'グラフィックフローラル',
  'グラフィックパターン',
  'グランジ',
  '手描き',
  'インク',
  'カレイドスコープ',
  'レイヤード',
  'リニア',
  'ライン',
  'ミニマル',
  'ミラー',
  'ミクストメディア',
  'モダン',
  'モノクロ',
  'ナイーブ',
  'オンブレ',
  'オプティカル',
  'ペイント',
  'フォトグラフィック',
  'ピクセル',
  'プレイフル',
  'プリティ',
  'ロマンチック',
  'スクリブル',
  'シルエット',
  'スケッチ',
  'ステンシル',
  'スワール',
  'シンメトリー',
  'トーナル',
  'ベクターパターン',
  'ヴィンテージ',
  '水彩',
];

export const tag_list_food_drink_jp = [
  'リンゴ',
  'バナナ',
  'キャンディ',
  'チェリー',
  'ドリンク',
  'フード',
  'フルーツ',
  'アイスクリーム',
  'レモン',
  'パイナップル',
  'イチゴ',
  'スイーツ',
  '野菜',
];

export const tag_list_objects_jp = [
  '建築',
  'ボート',
  '車',
  'チェーン',
  'クリスマス',
  '雲',
  'ダイヤモンド',
  '羽',
  'ギャラクシー',
  'ホリデー',
  'ジュエル',
  'ジャングル',
  '風景',
  'レター',
  'ノーティカル',
  '数字',
  'オーシャン',
  'ピープル',
  '植物',
  'スカル',
  '宇宙',
  '木',
  '壁紙',
  'ウェーブ',
  '包装紙',
];

export const tag_list_seasons_jp = [
  '秋',
  '秋冬',
  '秋',
  '秋冬',
  'ハロウィン',
  '真夏',
  'リゾート',
  '春',
  '春夏',
  '夏',
  '夏祭り',
  'バレンタイン',
  '冬',
];

export const tag_list_flowers_leaves_jp = [
  '竹',
  'ブルーム',
  'ブロッサム',
  'サボテン',
  '水仙',
  'デイジー',
  'シダ',
  'フォリッジ',
  '森',
  'フューシャ',
  'ハイビスカス',
  'アヤメ',
  'ラベンダー',
  'リーフ',
  'ユリ',
  'モクレン',
  '牧草地',
  '蘭',
  'パーム',
  'パンジー',
  '牡丹',
  '花びら',
  'ポピー',
  'ローズ',
  'チューリップ',
  'ワイルドフラワー',
];

export const tag_list_animals_birds_jp = [
  'ビートル',
  '鳥',
  '蝶',
  '猫',
  '犬',
  'イルカ',
  '象',
  '魚',
  'フラミンゴ',
  'カエル',
  'キリン',
  '馬',
  '昆虫',
  'レオパード',
  '蛾',
  'オウム',
  'ウサギ',
  'スネーク',
  'ヒトデ',
  'タイガー',
  'クジラ',
  'ゼブラ',
];
